import 'bootstrap'
import './sass/app.scss'
import 'owl.carousel';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import 'slick-carousel';


$(document).ready(function () {
    if (window.location.pathname === '/') {
        window.onscroll = function() {
            const navbar = document.getElementById("changing");
            const logo = document.getElementById("logo");
            if (window.pageYOffset > 0) {
                navbar.classList.remove("transparent");
                navbar.classList.add("white");
                logo.src = "/wp-content/themes/ZKPRUMIA/src/img/logo/ZKPRumia-Logo-short-28.svg";
            } else {
                navbar.classList.remove("white");
                navbar.classList.add("transparent");
                logo.src = "/wp-content/themes/ZKPRUMIA/src/img/logo/ZKPRumia-Logo-short-27.svg";
            }
        };
    } else {
        const navbar = document.getElementById("changing");
        navbar.classList.remove("transparent");
        navbar.classList.add("white");
        logo.src = "/wp-content/themes/ZKPRUMIA/src/img/logo/ZKPRumia-Logo-short-28.svg";
    }


    $('.navbar-wrap > nav > button').on('click', function () {
        $('.navbar-wrap').toggleClass('extended');
    });

    jQuery('.details-link').click(function() {
        var link = jQuery(this);
        var detailsSection = jQuery(link.attr('data-target'));
        if (detailsSection.hasClass('show')) {
            link.html('SZCZEGÓŁY');
        } else {
            link.html('ZWIŃ SZCZEGÓŁY');
        }
    });

    $('.slick-slider').slick({
        slidesToShow: 3,
        slidesToScroll: 1,
        dots: true,
        autoplay: false,
        autoplaySpeed: 3000,
        infinite: true,
        appendDots: $(".slide-m-dots"),
        prevArrow: $(".slide-m-prev"),
        nextArrow: $(".slide-m-next"),
        responsive: [
            {
                breakpoint: 992,
                settings: {
                    slidesToShow: 2,
                }
            },
            {
                breakpoint: 768,
                settings: {
                    slidesToShow: 1,
                }
            }
        ]
    });

    $('.slick-slider2').slick({
        slidesToShow: 3,
        slidesToScroll: 1,
        dots: true,
        autoplay: false,
        autoplaySpeed: 3000,
        infinite: true,
        appendDots: $(".slide-n-dots"),
        prevArrow: $(".slide-n-prev"),
        nextArrow: $(".slide-n-next"),
        responsive: [
            {
                breakpoint: 992,
                settings: {
                    slidesToShow: 2,
                }
            },
            {
                breakpoint: 768,
                settings: {
                    slidesToShow: 1,
                }
            }
        ]
    });
});





